/* insightsFilterThunks.ts */

/* Redux-Toolkit */
import { createAsyncThunk } from "@reduxjs/toolkit";

/* Utils */
import axiosInterceptor from "src/utils/helper/axios-interceptor";

/* Dto */
import { InsightsFilterResponseDto } from "src/utils/dto/insights-filter/InsightsFilterResponseDto";

/* Interfaces */
import { BaseInsightsFilterResponse } from "src/shared/interfaces/api/InsightsFilters";

export const fetchInsightsFilter = createAsyncThunk<
  BaseInsightsFilterResponse | undefined,
  string
>(
  "insightsFilter/fetchInsightsFilter",
  async (mainCondition: string) => {
    try {
      const response = await axiosInterceptor.get(
        "/options/filters",
        {
          params: {
            main_condition: mainCondition,
          },
        }
      );
      const dto = InsightsFilterResponseDto.fromApi(
        response.data
      );
      return dto.toObject();
    } catch (error) {
      return undefined;
    }
  }
);
